import { z } from 'zod';

export const entitlementNames = [
  'gtv_unlimited',
  'gtv_early_access',
  'unlimited',
  /** This has been deprecated on galatea and replaced by 'unlimited'. */
  'subscription',
  /** These are both for the ads supported subscription test. `with_ads` is from revcat and `unlimited_with_ads` is from stripe. */
  'with_ads',
  'unlimited_with_ads',
  'unlimited_app_bundle',
  'textonly',
  'audioonly',
  'pointsadd',
  'unknown',
] as const;

export const entitlementNameSchema = z.enum(entitlementNames);
export type EntitlementName = z.infer<typeof entitlementNameSchema>;
